import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import Header from "../components/Header";
import Navigation from "../components/Navigation";
import { Outlet } from "react-router-dom";
import { userService } from "../container";
import Loader from './Loader';
import GlobalState from '../state';

export default function Root() {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState();
  const [media, setMedia] = useState();

  useEffect(() => {
    (async () => {
      setLoading(true);

      try {
        const user = await userService.authorize();
        setUser(user);

        if (user && user.medias.length > 0) {
          const selectedMediaId = localStorage.getItem('media_id');
          const media = user.medias.find(media => media.id === selectedMediaId);

          if (media) {
            setMedia(media);
          } else {
            setMedia(user.medias[0]);
          }
        }
      } catch (err) {
        toast.error('Ocurrió un error de autorización.');
        console.error(err);
      }

      setLoading(false);
    })();
  }, []);

  if (loading) {
    return <Loader />;
  }

  if (!user) {
    return <Navigate replace to='/login' />;
  }

  if (user.medias.length === 0) {
    return <span>Sin autorización.</span>;
  }

  return (
    <>
      <Toaster />

      <GlobalState initialState={{ user, media }}>
        <div id="app">
          <Navigation />

          <div>
              <Header />

              <main>
                <Outlet />
              </main>
          </div>
        </div>
      </GlobalState>
    </>
  )
}
